import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";

import {CardActionsPort} from "@/modules/cardActions/CardActionsPort";

import {BranchOrderRepository} from "@/modules/branchOrder/adapter/BranchOrderRepository";
import {BranchOrderPort} from "@/modules/branchOrder/BranchOrderPort";
import {BranchOrderRestRepository} from "@/modules/branchOrder/adapter/rest/BranchOrderRestRepository";

export class BranchOrderPortFactory {
    private readonly authenticationProvider: AuthenticationProvider;
    private branchOrderRepository: BranchOrderRepository | null = null;

    private constructor(auth: AuthenticationProvider) {
        this.authenticationProvider = auth;
    }

    public static createBranchOrderPort(auth: AuthenticationProvider): BranchOrderPort {
        const factory = new BranchOrderPortFactory(auth);
        return new BranchOrderPort({
            branchOrderRepository: factory.getBranchOrderRepository(),
        });
    }

    private getBranchOrderRepository(): BranchOrderRepository {
        if (this.branchOrderRepository === null) {
            this.branchOrderRepository = new BranchOrderRestRepository(this.authenticationProvider);
        }
        return this.branchOrderRepository;
    }
}
